<div class="modal support-modal">
  <i class="fal fa-times modal__close"
     (click)="close()"></i>
  <h2 class="border-1 border-x-0 border-top-0 bg-color--gray p-0125">
    <i class="fal fa-headset color--gray"></i>
    Support Contact&hellip;
  </h2>

  <div class="support-dialog__body p-0125">
    <!-- Organizer and activist support-->
    <ng-container *ngIf="isInCampaign && !supportUser">
      <!-- Case where the user is in a campaign but there is no support user.
              This probably won't happen in production since the person who creates
              the campaign is made the support by default-->
      <div class="alert alert--warning mb-0100">
        <h5 class="alert__heading alert-color mb-0050">
          <i class="fas fa-exclamation-triangle mr-0025"></i>
          No support contact
        </h5>
        <div class="alert__content">
          <p class="mb-0">A support contact has not been set up for this campaign.</p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="supportUser">
      <div class="support-user pb-0075">
        <div class="support-user__id">
          <span class="person__name">{{supportUser | fullName }}</span>
          <span class="person__location">
            {{supportUser.role}}
          </span>
        </div>
        <div class="support-user__contact-info">
          <div class="email mt-0050">
            <a class="pair__link link link--noline"
               [attr.href]="'mailto:' + supportUser.email">{{supportUser.email}}</a>
          </div>
          <div class="phone mt-0025"
               *ngIf="supportUser.phoneNumber">
            <a class="pair__link link link--noline link--black"
               title="{{supportUser.phoneNumber | phone}}"
               href="tel:{{supportUser.phoneNumber}}">{{supportUser.phoneNumber | phone}}</a>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Lead and admin support-->
    <ng-container *appIfInRole="['administrator', 'lead']">
      <div class="border-1 border-x-0 border-bottom-0 pt-0075 pb-0075 txt-14">
        <span>Or contact Action Builder: </span>
        <a class="link link--noline"
           href="mailto:support@actionbuilder.org">support&#64;actionbuilder.org</a>
      </div>
    </ng-container>
    <div class="border-1 border-x-0 border-bottom-0 pt-0075 txt-14">
      <a class="link link--noline link--blue"
         href="https://actionbuilder.zendesk.com/hc/en-us"
         target="_blank">Visit the Help Center</a>
    </div>
  </div>
  <div class="support-dialog__footer border-1 border-x-0 border-bottom-0 bg-color--gray p-0125 pt-0075 pb-0075">
    <small class="d-block">Version: {{version}}</small>
    <small class="d-block pt-0050"
           *ngIf="isDev">
      <button type="button"
              class="link link--noline p-0"
              (click)="enableProdFeatureFlags()"
              *ngIf="!isProdFeatureFlagEnabled()">
        Enable Prod Feature Flags
      </button>
      <button type="button"
              class="link link--red link--noline p-0"
              (click)="disableProdFeatureFlags()"
              *ngIf="isProdFeatureFlagEnabled()">
        Disable Prod Feature Flags
      </button>
    </small>

  </div>
</div>
